import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=8abca2e8&"
import script from "./CampaignEdit.vue?vue&type=script&lang=ts&"
export * from "./CampaignEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports